const isDev = !!import.meta.env?.DEV;

export const env = {
  ENABLE_ADMIN: import.meta.env?.VITE_ENABLE_ADMIN === 'true',
  // Em dev SEMPRE usamos o proxy do Vite para evitar CORS/cookies cross-origin
  API_URL: isDev ? '' : (import.meta.env?.VITE_API_URL || ''),
  APP_NAME: import.meta.env?.VITE_APP_NAME || 'Spotify Global Radar',
  NODE_ENV: import.meta.env?.NODE_ENV || 'development',
  DEV: import.meta.env?.DEV || false,
};
